import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const RightArrow = createSvgIcon(
  <path d="m12.75 19.341-1.59-1.591 5.079-5.08H3.455v-2.25h12.783l-5.08-5.079 1.593-1.591 7.794 7.795-7.795 7.796Z" />,
  'RightArrow'
);

export { RightArrow };
